import React from "react";
import { useTranslation } from "i18n";
import { useGetGallery } from "pages/Profile/hooks/useGetGallery";
import { getImageUrl } from "services/UrlBuilder";
import { ImageLocation } from "models";
import getImageAltText from "pages/Profile/utils/getImageAltText";

const GalleryPrint = () => {
  const { t } = useTranslation();
  const { gallery = [] } = useGetGallery();

  const [, ...photos] = gallery;

  return (
    <div className="my-2.5 flex h-14 w-full gap-1 overflow-x-hidden">
      {photos.map((photo) => (
        <div
          key={photo.url}
          className="h-full w-auto flex-none overflow-hidden border border-gray-200 bg-gray-100"
        >
          <img
            src={getImageUrl(photo.url, ImageLocation.ViewPhoto)}
            alt={getImageAltText({
              t,
              description: photo?.description,
              photographer: photo?.photographer,
            })}
            className="block h-full w-auto object-contain"
          />
        </div>
      ))}
    </div>
  );
};

export default GalleryPrint;
